export default __webpack_public_path__ + "static/media/thumbs_up_down-gray.fe15928d.svg";